<template>
  <div>
    <v-container v-if="loading" class="fill-height pa-0 align-start" fluid>
      <v-progress-linear indeterminate></v-progress-linear>
    </v-container>
    <v-container v-else :fluid="$vuetify.breakpoint.lgAndDown" class="px-8 py-2 white">
      <v-dialog v-model="dialog" scrollable fullscreen>
        <AddNotice v-if="dialog" @closeDialog="dialog = false" />
      </v-dialog>
      <v-dialog v-model="dialogEdit" scrollable fullscreen>
        <EditNotice
          v-if="dialogEdit"
          @closeDialogEdit="dialogEdit = false"
          :noticeSelected="selectedNotice"
        />
      </v-dialog>
      <v-dialog
        v-model="dialogFinalizado"
        persistent
        scrollable
        max-width="800"
        :fullscreen="!$vuetify.breakpoint.mdAndUp"
      >
        <v-card v-if="selectedNotice" :disabled="loadingNotice" :loading="loadingNotice">
          <v-card-title class="display-1">
            {{ selectedNotice.titulo }}
            <v-spacer></v-spacer>
            <v-btn icon @click="dialogFinalizado = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-subtitle
            class="subtitle font-weight-bold pt-4 pb-0"
          >¿Encontraste lo que estabas buscando?</v-card-subtitle>
          <v-card-subtitle
            class="subtitle font-weight-bold primary--text pb-2"
          >Selecciona el postulante que fue seleccionado para el puesto.</v-card-subtitle>
          <v-divider></v-divider>
          <v-card-text v-if="!loadingNotice" class="pt-4 accent">
            <v-col class="pa-0">
              <span class="mr-2 grey--text">Total hojas de vidas:</span>
              <span class="font-weight-bold mr-1 info--text">{{ selectedNotice.postulantes.length }}</span>
            </v-col>
            <CardApplicantFinalizar
              v-for="postulante in sortPostulantes(selectedNotice.postulantes)"
              :key="postulante._id"
              :applicant="postulante"
              :requerimientos="selectedNotice.requerimientos"
              :aviso="{ area: selectedNotice.area }"
              :select="selectPostulant"
              @click="selectPostulant ? selectPostulant = undefined : selectPostulant = postulante; isWithoutPostulant = false"
              class="mb-2"
            ></CardApplicantFinalizar>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="px-6 py-4 flex-wrap">
            <v-switch
              hide-details
              class="mt-0 mb-4"
              v-if="!selectPostulant"
              v-model="isWithoutPostulant"
              inset
              label="No encontré lo que buscaba o prefiero no decirlo"
            ></v-switch>
            <v-spacer></v-spacer>
            <BaseMyButton
              :disabled="!isWithoutPostulant && !selectPostulant"
              color="error"
              @click="finalizarNotice()"
            >Finalizar</BaseMyButton>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-row>
        <v-col class="d-flex pb-0 flex-wrap">
          <BaseMyButtonDirection
            direction="left"
            :animate="true"
            :to="{ name: 'administrator companies' }"
          ></BaseMyButtonDirection>
          <p class="display-2 font-weight-bold ml-4 mb-0">Avisos</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex">
          <v-spacer v-if="!$vuetify.breakpoint.xsOnly"></v-spacer>
          <v-select
            @change="changeStatusNotice"
            v-if="$vuetify.breakpoint.smAndDown"
            :value="tabs[selectedStatusNotice]"
            return-object
            :items="tabs"
            filled
            hide-details
            rounded
            :disabled="loadingDataTable"
            :style="`${$vuetify.breakpoint.xsOnly ? '100%' : 'max-width: 230px'}`"
          >
            <template v-slot:item="data">
              {{ data.item }}
              <v-chip
                class="ml-2"
                small
                :color="tabs[selectedStatusNotice] === data.item ? 'primary' : 'deep-orange lighten-5'"
                :class="[{
                  'primary--text': tabs[selectedStatusNotice] !== data.item,
                }, 'font-weight-bold']"
                label
              >{{ getNoticesLengthByEstadoName(data.item) }}</v-chip>
            </template>
            <template v-slot:selection="data">
              <span class="font-weight-bold primary--text">{{ data.item }}</span>
              <v-chip
                class="ml-2"
                small
                color="primary"
                label
              >{{ getNoticesLengthByEstadoName(data.item) }}</v-chip>
            </template>
          </v-select>
          <v-tabs
            v-else
            v-model="selectedStatusNotice"
            fixed-tabs
            background-color="transparent"
            color="primary"
            show-arrows
          >
            <v-tab
              v-for="(item, index) in tabs"
              :key="item"
              :class="[
                'justify-start',
                'caption',
              ]"
              active-class="font-weight-bold"
              style="border-bottom: thin solid rgba(0,0,0,0.1); border-top: thin solid rgba(0,0,0,0.1);"
            >
              <span>{{ item }}</span>
              <v-chip
                class="ml-2"
                small
                :color="tabs[selectedStatusNotice] === item ? 'primary' : 'deep-orange lighten-5'"
                :class="[{
                  'primary--text': tabs[selectedStatusNotice] !== item,
                }, 'font-weight-bold']"
                label
              >{{ getNoticesLengthByEstado(index) }}</v-chip>
            </v-tab>
          </v-tabs>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            placeholder="Search"
            filled
            dense
            hide-details
            rounded
            class="mb-3"
          ></v-text-field>
          <v-card flat :loading="loadingDataTable" :disabled="loadingDataTable">
            <v-divider></v-divider>
            <v-data-table
              :headers="headers"
              :items="noticesByEstado"
              :search="search"
              @click:row="noticeDatail"
              class="transparent"
              style="cursor: pointer"
            >
              <template v-slot:item.createdAt="{ item }">
                <span v-if="item.estado !== 'Finalizado'">{{ getFormatDate(item.createdAt) }}</span>
                <v-tooltip top v-else>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{ getFormatDate(item.createdAt) }}</span>
                  </template>
                  <span>Finalizado el {{ getFormatDate(item.updatedAt) }}</span>
                </v-tooltip>
              </template>
              <template v-slot:item.estado="{ item }">
                <v-chip
                  v-if="item.estado === 'Publicado'"
                  class="success--text font-weight-bold"
                  color="success lighten-5"
                >{{ item.estado }}</v-chip>
                <v-chip
                  v-else-if="item.estado === 'Finalizado'"
                  class="error--text font-weight-bold"
                  color="error lighten-5"
                >{{ item.estado }}</v-chip>
                <v-chip
                  v-else-if="item.estado === 'Eliminado'"
                  class="error--text font-weight-bold"
                  color="error lighten-5"
                >{{ item.estado }}</v-chip>
                <v-chip
                  v-else-if="item.estado === 'Borrador'"
                  class="grey--text font-weight-bold"
                  color="grey lighten-5"
                >{{ item.estado }}</v-chip>
                <v-menu offset-y min-width="150">
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on" class="ml-2">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      @click="changeStatus(item._id, 'Publicado')"
                      v-if="item.estado !== 'Publicado'"
                    >
                      <v-list-item-title>Publicar</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="finalizar(item)" v-if="item.estado !== 'Finalizado'">
                      <v-list-item-title>Finalizar</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click="changeStatus(item._id, 'Eliminado')"
                      v-if="item.estado !== 'Eliminado'"
                    >
                      <v-list-item-title>Eliminar</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click="changeStatus(item._id, 'Borrador')"
                      v-if="item.estado !== 'Borrador'"
                    >
                      <v-list-item-title>Borrador</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AddNotice from "@/components/AddNotice.vue";
import EditNotice from "@/components/EditNotice.vue";
import CardApplicantFinalizar from "@/components/CardApplicantFinalizar.vue";

import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

import { windowSizeMixin } from "@/mixin/windowSizeMixin.js";
import { mapActions, mapState } from "vuex";

import store from "@/store";

export default {
  name: "CompanyNotices",
  components: {
    AddNotice,
    EditNotice,
    CardApplicantFinalizar
  },
  mixins: [validationMixin, windowSizeMixin],
  validations: {},
  data() {
    return {
      loading: false,
      loadingNotice: false,
      loadingDataTable: false,
      selectedStatusNotice: 0,
      selectPostulant: undefined,
      tabs: ["Todo", "Publicados", "Finalizados", "Eliminados", "Borradores"],
      selectJob: null,
      dialog: false,
      dialogEdit: false,
      search: "",
      headers: [
        {
          text: "TÍTULO",
          align: "start",
          value: "titulo",
          class: "font-weight-bold grey--text"
        },
        {
          text: "ESTADO",
          value: "estado",
          class: "font-weight-bold grey--text",
          width: 170
        },
        {
          text: "PUBLICACIÓN",
          value: "createdAt",
          class: "font-weight-bold grey--text"
        },
        {
          text: "PUBLICADO POR",
          value: "miembro.full_name",
          class: "font-weight-bold grey--text"
        },
        {
          text: "VISITAS",
          value: "total_visitas",
          class: "font-weight-bold grey--text",
          align: "center",
          sortable: false
        },
        {
          text: "HV RECIBIDAS",
          value: "hv_recibidas",
          class: "font-weight-bold grey--text",
          align: "center",
          sortable: false
        },
        {
          text: "HV NO LEÍDAS",
          value: "hv_no_leidas",
          class: "font-weight-bold grey--text",
          align: "center",
          sortable: false
        }
      ],
      isWithoutPostulant: false,
      selectedNotice: undefined,
      dialogFinalizado: false
    };
  },
  computed: {
    ...mapState("administration/notices", ["notices"]),
    noticesPublicadosComputed() {
      return this.notices.filter(notice => notice.estado === "Publicado");
    },
    noticesFinalizadosComputed() {
      return this.notices.filter(notice => notice.estado === "Finalizado");
    },
    noticesBorradoresComputed() {
      return this.notices.filter(notice => notice.estado === "Borrador");
    },
    noticesEliminadosComputed() {
      return this.notices.filter(notice => notice.estado === "Eliminado");
    },
    noticesByEstado() {
      if (this.selectedStatusNotice === 0) return this.notices;
      else if (this.selectedStatusNotice === 1)
        return this.noticesPublicadosComputed;
      else if (this.selectedStatusNotice === 2)
        return this.noticesFinalizadosComputed;
      else if (this.selectedStatusNotice === 3)
        return this.noticesEliminadosComputed;
      else if (this.selectedStatusNotice === 4)
        return this.noticesBorradoresComputed;
    }
  },
  created() {
    this.getPageEvents();
  },
  methods: {
    getPageEvents() {
      this.loadingDataTable = true;
      store
        .dispatch("administration/notices/retrieveNotices", this.$route.params.id)
        .then(() => {})
        .finally(() => {
          this.loadingDataTable = false;
        });
    },
    retrieveNotice(id) {
      this.loadingNotice = true;
      store
        .dispatch("administration/notices/retrieveNoticeById", { empresa: this.$route.params.id, id })
        .then(notice => {
          this.selectedNotice = notice;
        })
        .finally(() => {
          this.loadingNotice = false;
        });
    },
    noticeDatail(notice) {
      this.$router.push({
        name: "administrator companies notices by id",
        params: { empresa: this.$route.params.id, id: notice._id }
      });
    },
    getFormatDate(date) {
      return this.$moment(date).format("DD/MM/YYYY");
    },
    getNoticesLengthByEstado(index) {
      if (index === 0) return this.notices.length;
      else if (index === 1) return this.noticesPublicadosComputed.length;
      else if (index === 2) return this.noticesFinalizadosComputed.length;
      else if (index === 3) return this.noticesEliminadosComputed.length;
      else if (index === 4) return this.noticesBorradoresComputed.length;
    },
    getNoticesLengthByEstadoName(name) {
      if (name === "Todo") return this.notices.length;
      else if (name === "Publicados")
        return this.noticesPublicadosComputed.length;
      else if (name === "Finalizados")
        return this.noticesFinalizadosComputed.length;
      else if (name === "Eliminados")
        return this.noticesEliminadosComputed.length;
      else if (name === "Borradores")
        return this.noticesBorradoresComputed.length;
    },
    finalizar(notice) {
      this.dialogFinalizado = true;
      this.selectedNotice = notice;
      this.retrieveNotice(notice._id);
    },
    finalizarNotice() {
      this.loadingNotice = true;
      const data = this.selectPostulant
        ? { postulante: this.selectPostulant.postulante._id }
        : {};
      store
        .dispatch("administration/notices/finalizarNotice", {
          notice: this.selectedNotice._id,
          data,
          empresa: this.$route.params.id,
        })
        .then(() => {
          this.selectPostulant = undefined;
          this.selectedNotice = undefined;
          this.dialogFinalizado = false;
          this.getPageEvents();
          this.$store.commit("SET_ALERT", {
            color: "green",
            text: "Aviso finalizado",
            visible: true
          });
        })
        .finally(() => {
          this.loadingNotice = false;
        });
    },
    sortPostulantes(postulantes) {
      return [...postulantes].sort((a, b) => b.es_favorito - a.es_favorito);
    },
    changeStatus(id, estado) {
      this.loadingDataTable = true;
      store
        .dispatch("administration/notices/changeStatus", {
          notice: id,
          empresa: this.$route.params.id,
          data: { estado }
        })
        .then(() => {
          this.getPageEvents();
          this.$store.commit("SET_ALERT", {
            color: "green",
            text: `Aviso cambiado a ${estado}`,
            visible: true
          });
        })
        .finally(() => {
          this.loadingDataTable = false;
        });
    },
    changeStatusNotice(event) {
      this.selectedStatusNotice = this.tabs.indexOf(event);
    }
  }
};
</script>

<style>
</style>